export default "__VITE_ASSET__B7229pFw__ 480w, __VITE_ASSET__DAnKpSMs__ 768w, __VITE_ASSET__DEJiJ8Ui__ 1200w, __VITE_ASSET__DwtxTaY8__ 1920w";